import { ISalariesSummaryRequest } from '../../interfaces/salaries-summary.interface'

export class GetSalariesDetail {
  static readonly type = '[SalariesDetail] Get Salaries Detail'
  constructor(public payload: ISalariesSummaryRequest) {}
}

export class ResetSalariesDetail {
  static readonly type = '[SalariesDetail] Reset Salaries Detail'
}
